import { idpcState, loadStyle, isString, injectStyle, } from "@ideal-postcodes/jsutil";
/**
 * Default CSS
 *
 * @hidden
 */
const d = ".idpc_ul.hidden{display:none}div.idpc_autocomplete{position:relative;margin:0;padding:0;border:0}div.idpc_autocomplete>input{display:block}div.idpc_autocomplete>ul{position:absolute;left:0;z-index:999;min-width:100%;box-sizing:border-box;list-style:none;padding:0;border-radius:.3em;margin:.2em 0 0;background:#fff;border:1px solid rgba(0,0,0,.3);box-shadow:.05em .2em .6em rgba(0,0,0,.2);text-shadow:none;max-height:250px;overflow-y:scroll}div.idpc_autocomplete>ul>li{position:relative;padding:.2em .5em;cursor:pointer}div.idpc_autocomplete>ul>li:hover{background:#b8d3e0;color:#000}div.idpc_autocomplete>ul>li.idpc_error{font-style:italic;background-color:#eee;cursor:default!important}div.idpc_autocomplete>ul>li[aria-selected=true]{background:#3d6d8f;color:#fff;z-index:1000}div.idpc_autocomplete>.idpc-unhide{font-size:90%;text-decoration:underline;cursor:pointer}@supports (transform:scale(0)){div.idpc_autocomplete>ul{transition:.3s cubic-bezier(.4, .2, .5, 1.4);transform-origin:1.43em -0.43em}div.idpc_autocomplete>ul:empty,div.idpc_autocomplete>ul[hidden]{opacity:0;transform:scale(0);display:block;transition-timing-function:ease}}";
/**
 * Injects CSS style into DOM
 *
 * Idempotent
 *
 * @hidden
 */
export const addStyle = (c) => {
    const style = c.options.injectStyle;
    if (!style)
        return;
    const g = idpcState();
    if (!g.afstyle)
        g.afstyle = {};
    if (isString(style) && !g.afstyle[style]) {
        g.afstyle[style] = true;
        const link = loadStyle(style, c.document);
        c.document.head.appendChild(link);
        return link;
    }
    if (style === true && !g.afstyle[""]) {
        g.afstyle[""] = true;
        return injectStyle(d, c.document);
    }
    return;
};
